﻿import './Hero.css'
import { useBookDemo } from './BookDemoContext'

export default function Hero() {
  const openBookDemo = useBookDemo()
  const scrollTo = (id: string) => {
    const el = document.getElementById(id)
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
  }
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-eyebrow">AI Workforce Intelligence Platform</div>
          <h1>The AI Workforce<br/>Intelligence Platform</h1>
          <p className="hero-subtitle">
            One conversational AI platform connecting hiring, skill assessment, career
            development, and enterprise knowledge — generating actionable intelligence
            across the entire employee lifecycle.
          </p>
          <div className="hero-cta">
            <button className="btn-primary btn-large" onClick={() => scrollTo('platform')}>Explore the Platform</button>
            <button className="btn-secondary btn-large hero-secondary-btn" onClick={() => openBookDemo('Book a Demo')}>Book a Demo</button>
          </div>
          <div className="trust-indicators">
            Trusted by enterprise teams &bull; Fortune 100 deployments &bull; 100,000+ users
          </div>
          <div className="hero-try">
            <p className="hero-try-label">No sales pitch. See the platform in action.</p>
            <button className="hero-try-btn" onClick={() => scrollTo('products')}>
              <span className="hero-try-play">&#9654;</span> Try SmartHire Now
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
